
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/Fashion-trends",
      function () {
        return require("private-next-pages/blog/Fashion-trends/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/Fashion-trends"])
      });
    }
  